import { render, staticRenderFns } from "./recipe-filter-app.vue?vue&type=template&id=067e46df&"
import script from "./recipe-filter-app.vue?vue&type=script&lang=js&"
export * from "./recipe-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports